module.exports = __webpack_public_path__ + "img/kefu.7e9ebdc4.gif";